import { CustomYup } from 'validations/CustomYup'

const newBillingSchema = CustomYup.object().shape({
  user: CustomYup.object().required(),
  taskIds: CustomYup.array().min(1, 'Prosze wybrać przynajmniej jedno zadanie.').required(),
})

export default newBillingSchema
